import styled from "styled-components";

import { ActivityLessonVideoContainer } from "pages/[tenant]/g/[group_slug]/classwork/[topic_slug]/[activitie_slug]/components/organisms/ActivityLessonVideo/styles";
import { ImageFallback } from "pages/[tenant]/g/[group_slug]/classwork/[topic_slug]/[activitie_slug]/components/templates/ImersiveLessonPage/components/atoms/TopicLesson/styles";

export const LessonVideoPlayerContainer = styled.div`
  margin-top: 1rem;

  iframe {
    width: -webkit-fill-available;
  }

  .not-released-container {
    position: relative;

    aspect-ratio: 16/9;

    display: grid;
    grid-template-areas: "content";
    justify-items: center;
    align-items: center;

    &,
    .image-container {
      height: 100%;
      width: 100%;

      position: relative;

      :has(.not-released-background) {
        .missing-image-icon {
          display: none;
        }
      }
    }

    img {
      border-radius: 8px;
      z-index: 1;
    }

    .not-released-background {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      height: 100%;

      z-index: 2;

      backdrop-filter: blur(4px) brightness(0.7);
    }

    .image-container,
    .not-released-background {
      grid-area: content;

      ${ImageFallback} {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        border-radius: 8px;
      }
    }

    .image-container {
      filter: grayscale(100%);
    }

    .drip-content-message-container {
      padding: 0.1875rem 0.5rem;
      border-radius: 4px;

      white-space: nowrap;

      text-align: center;
      font: 600 0.75rem/1.125rem "Inter";
      color: ${({ theme }) =>
        theme?.classwork?.imersive?.dripContentFlagTextColor};

      background-color: ${({ theme }) =>
        theme?.classwork?.imersive?.dripContentFlagBackgroundColor};

      display: flex;
      align-items: center;
      gap: 0.25rem;

      width: fit-content;
    }
  }

  > .loader {
    height: 100%;
    align-items: center;
  }

  ${ActivityLessonVideoContainer} {
    max-width: initial;
    margin: initial;

    iframe {
      padding: initial;
    }
  }
`;
